import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EReviewDetailsActionTypes {
  SetReviewReviewDetailsOpen = 'developer/setReviewReviewDetailsOpen',
  SetReviewReviewDetailsClose = 'developer/setReviewReviewDetailsClose',
}

export type TSetReviewDetailsActionPayload = {
  reviewId: string | null;
};

export type TSetReviewDetailsOpen = ITypedReduxAction<
  EReviewDetailsActionTypes.SetReviewReviewDetailsOpen,
  TSetReviewDetailsActionPayload
>;

export type TSetReviewDetailsClose = ITypedReduxAction<EReviewDetailsActionTypes.SetReviewReviewDetailsClose, void>;

export type TSetReviewDetailsActions = TSetReviewDetailsOpen | TSetReviewDetailsClose;

/**
 * Redux action, который записывает в store информцию о просмотре отзывов
 */
export const setReviewDetailsOpenAction: (payload: TSetReviewDetailsActionPayload) => TSetReviewDetailsOpen =
  actionGenerator<EReviewDetailsActionTypes.SetReviewReviewDetailsOpen, TSetReviewDetailsActionPayload>(
    EReviewDetailsActionTypes.SetReviewReviewDetailsOpen,
  );

export const setReviewDetailsCloseAction: () => TSetReviewDetailsClose =
  actionGenerator<EReviewDetailsActionTypes.SetReviewReviewDetailsClose>(
    EReviewDetailsActionTypes.SetReviewReviewDetailsClose,
  );
